import { render, staticRenderFns } from "./PeriodList.vue?vue&type=template&id=1812d2dc&scoped=true"
import script from "./PeriodList.vue?vue&type=script&lang=js"
export * from "./PeriodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812d2dc",
  null
  
)

export default component.exports